<template>
  <!--  解决方案 -->
  <div class="">
    <HeaderTop />
    <MenuPage />

    <BannerDetail
      :backgroundImage="require('../assets/img/banner9.jpg')"
      :title="$t('solution.items[3].title')"
      :description="$t('solution.items[3].description')"
    />
 <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec1") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>

       
      </div>
    </div>

       <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("Solutiondec99") }}</div>
      </div>
    </div>



    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec2") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

        <div class="solution-main">
      <div class="solution-box-two">
        <div class="solution-box-three">
          <div class="title-top">01</div>
          <div class="title-bottom">{{ $t("Solutiondec100") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">02</div>
          <div class="title-bottom">{{ $t("Solutiondec101") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">03</div>
          <div class="title-bottom">{{ $t("Solutiondec102") }}</div>
        </div>
        <div class="solution-box-three">
          <div class="title-top">04</div>
          <div class="title-bottom">{{ $t("Solutiondec103") }}</div>
        </div>
      </div>
    </div>


    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec3") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    
     <div class="solution-main">
      <div class="solution-box">
        <div class="solution-title-one">{{ $t("Solutiondec104") }}</div>

        <div class="img-box">
           <img :src=" $t('image1') " class="img-li" />
        </div>
        
      </div>
    </div>



    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec4") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

     <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-two">
          <img src="../assets/img/an11.png" class="item-one-img" />
          <div class="title-home-two">{{ $t("Solutiondec105") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec109") }}</p>
        </div>
        <div class="item-two">
          <img src="../assets/img/an12.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec106") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec110") }}</p>
        </div>
        <div class="item-two">
          <img src="../assets/img/an13.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec107") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec111") }}</p>
        </div>
         <div class="item-two">
          <img src="../assets/img/an14.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec108") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec112") }}</p>
        </div>
      </div>
    </div>


    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec5") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>


      <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-three">
          <img src="../assets/img/an22.png" class="item-one-img" />
          <div class="title-home-two">{{ $t("Solutiondec113") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec115") }}</p>
        </div>
        <div class="item-three">
          <img src="../assets/img/an23.png" class="item-one-img"  />
          <div class="title-home-two">{{ $t("Solutiondec114") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec116") }}</p>
        </div>
      </div>
    </div>



    <div class="title-home-main">
      <div class="title-home-box">
        <div class="title-home-one">{{ $t("Solutiondec6") }}</div>
        <div><i class="iconfont icon-hengtiao"></i></div>
      </div>
    </div>

    
      <div class="solution-main">
      <div class="solution-box-four">
        <div class="item-one">
          <img src="../assets/img/jie7.jpg" class="item-two-img" />
          <div class="title-home-two">{{ $t("Solutiondec117") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec120") }}</p>
        </div>
        <div class="item-one">
          <img src="../assets/img/jie10.jpg" class="item-two-img"  />
          <div class="title-home-two">{{ $t("Solutiondec118") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec121") }}</p>
        </div>
         <div class="item-one">
          <img src="../assets/img/jie8.jpg" class="item-two-img"  />
          <div class="title-home-two">{{ $t("Solutiondec119") }}</div>
          <p class="solution-title-one">{{ $t("Solutiondec122") }}</p>
        </div>
      </div>
    </div>

  

    <div class="footer-main">
      {{ $t("footertitile") }}
    </div>
  </div>
</template>

<script>
import MenuPage from "../components/MenuPage.vue";
import HeaderTop from "../components/HeaderTop.vue";
import BannerDetail from "@/components/BannerDetail.vue";
export default {
  components: { HeaderTop, MenuPage, BannerDetail },
  name: "NewsPage",
   mounted() {
    this.scrollToTop();
  },
  data() {
    return {
      companyName: "",
      contactPerson: "",
      contactInfo: "",
      requirements: "",
    };
  },
  methods: {
      scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleSubmit() {
      // 阻止表单的默认提交行为
      alert("提交成功"); // 提示提交成功
      // 这里可以添加进一步的逻辑，比如将表单数据发送到服务器
      console.log({
        companyName: this.companyName,
        contactPerson: this.contactPerson,
        contactInfo: this.contactInfo,
        requirements: this.requirements,
      });
    },
  },
};
</script>
<style scoped>
</style>